import React from 'react';
import styled from 'styled-components';
import Desktop from '@components/shared/Desktop';
import Tablet from '@components/shared/Tablet';
import BannerMobilePPC1 from '@images/banners/banner-mobile-ppc-1.png';
import BannerMobilePPC2 from '@images/banners/banner-mobile-ppc-2.png';
import BannerMobileProviotics1 from '@images/banners/banner-mobile-proviotics-1.png';
import BannerMobileTampons1 from '@images/banners/banner-mobile-tampons-1.png';
import BannerMobileTampons2 from '@images/banners/banner-mobile-tampons-2.png';
import BannerMobileTampons3 from '@images/banners/banner-mobile-tampons-3.png';
import BannerMobileVMS from '@images/banners/banner-mobile-vms-new.png';
import BannerPPC1 from '@images/banners/banner-ppc-1.png';
import BannerPPC2 from '@images/banners/banner-ppc-2.png';
import BannerProviotics1 from '@images/banners/banner-proviotics-1.png';
import BannerTampons1 from '@images/banners/banner-tampons-1.png';
import BannerTampons2 from '@images/banners/banner-tampons-2.png';
import BannerTampons3 from '@images/banners/banner-tampons-3.png';
import BannerVMS from '@images/banners/banner-vms.png';

interface Props {
  id: string;
}

interface BannerItem {
  id: string;
  link: string;
  image: any;
  mobileImage: any;
  alt: string;
}

export default function ArticleShoppingModule({ id }: Props) {
  const bannerOptions: BannerItem[] = [
    {
      id: 'proviotics-1',
      link: 'https://www.yourdaye.com/products/proviotics',
      image: BannerProviotics1,
      mobileImage: BannerMobileProviotics1,
      alt: 'Daye Proviotics Banner'
    },
    {
      id: 'tampons-1',
      link: 'https://www.yourdaye.com/products/tampons/',
      image: BannerTampons1,
      mobileImage: BannerMobileTampons1,
      alt: 'Daye Tampons Banner'
    },
    {
      id: 'tampons-2',
      link: 'https://www.yourdaye.com/products/tampons/',
      image: BannerTampons2,
      mobileImage: BannerMobileTampons2,
      alt: 'Daye Tampons Banner'
    },
    {
      id: 'tampons-3',
      link: 'https://www.yourdaye.com/products/tampons/',
      image: BannerTampons3,
      mobileImage: BannerMobileTampons3,
      alt: 'Daye Tampons Banner'
    },
    {
      id: 'vms',
      link: 'https://www.yourdaye.com/products/at-home-vaginal-screening/',
      image: BannerVMS,
      mobileImage: BannerMobileVMS,
      alt: 'Daye Diagnostic Tampon Banner'
    },
    {
      id: 'ppc-1',
      link: 'https://www.yourdaye.com/period-pain-clinic/',
      image: BannerPPC1,
      mobileImage: BannerMobilePPC1,
      alt: 'Daye Period Pain Clinic Banner'
    },
    {
      id: 'ppc-2',
      link: 'https://www.yourdaye.com/period-pain-clinic/',
      image: BannerPPC2,
      mobileImage: BannerMobilePPC2,
      alt: 'Daye Period Pain Clinic Banner'
    }
  ];

  function renderBanner(banner: BannerItem) {
    return (
      <Container onClick={() => window.open(`${banner.link}?banner=${banner.id}`)}>
        <Desktop>
          <BannerImage src={banner.image} alt={banner.alt} width="1100" height="196" />
        </Desktop>
        <Tablet>
          <BannerImage src={banner.mobileImage} alt={banner.alt} width="630" height="520" />
        </Tablet>
      </Container>
    );
  }

  const bannerMatch = bannerOptions.find((banner: BannerItem) => banner.id === id);
  const randomIndex = Math.floor(Math.random() * 3) + 1;
  const randomTamponMatch = bannerOptions.find((banner: BannerItem) => banner.id === `tampons-${randomIndex}`);

  if (bannerMatch) {
    return renderBanner(bannerMatch);
  }
  if (id === 'random-tampons' && randomTamponMatch) {
    return renderBanner(randomTamponMatch);
  }
  return null;
}

const Container = styled.div`
  width: 550px;
  max-width: 100%;
  margin: 30px auto;
  cursor: pointer;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
`;
